import React, { useState } from 'react';
import PageHeader from '../../../../components/PageHeader';
import { useTheme } from '@emotion/react';
import { Stack, Typography } from '@mui/material';
import SubjectOfReportCard from './SubjectOfReportCard';
import { useTranslation } from 'react-i18next';
import NoDataFound from '../../../../components/NoDataFound/NoDataFound';
import { CancelToken } from 'apisauce';
import appapi from '../../../../api/apiClient';
import { setLoading } from '../../../../redux/features/appSlice';
import { useEffect } from 'react';
import ActivityIndicator from '../../../../components/DataTable/ActivityIndicator';

export default function Reports({ company }) {
  const theme = useTheme();
  const text = theme.palette.primary.text;
  const textLight = theme.palette.primary.textLight;
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);

  const [payload, setPayload] = useState({
    page: 1,
    limit: 10,
    filter: null,
    totalLength: 0,
    paginationPage: 0,
  });

  const handleSearchEmit = (search) => {
    setPayload((prevState) => ({ ...prevState, paginationPage: 0, page: 1, limit: 50, filter: search }));
  };

  let source2 = CancelToken.source();

  const [data, setReportList] = useState([]);

  const getReports = async () => {
    setLoading(true);
    source2.cancel();
    source2 = CancelToken.source();
    const response = await appapi.get(
      `client-management/listForInteligenceReport/${company?.companyId}/${company?.traderId}`,
      { pageNumber: payload?.page, pageSize: payload?.limit, filter: payload?.filter },
      {
        cancelToken: source2.token,
      },
    );
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        setReportList(data?.response?.response);
      }
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (company && company?.companyId) {
      getReports();
    } else {
    }
    return () => {
      if (source2) {
        source2.cancel();
      }
    };
  }, [company, payload?.filter]);

  return (
    <Stack className='flex-overflow'>
      <PageHeader
        tableType={'2'}
        handleFilterButton={true}
        handleOnSearchEmit={(search) => {
          handleSearchEmit(search);
        }}
      >
        <Stack
          direction="row"
          flex={1}
          alignItems={'center'}
          justifyContent={'space-between'}
        >
          <Typography
            className="fs-14 ff-Roboto fw-medium"
            color={text}
          >
            {t('Reports')}
          </Typography>
        </Stack>
        <Stack flexGrow={1} />
      </PageHeader>
      {data.length === 0 && !loading && <NoDataFound />}
      {loading && (
        <Stack
          flex={1}
          alignItems={'center'}
          justifyContent={'center'}
        >
          <ActivityIndicator />
        </Stack>
      )}
      {!loading && (
        <Stack className="px-[16px]">
          {data?.map((item, index) => (
            <SubjectOfReportCard data={item} />
          ))}
        </Stack>
      )}
    </Stack>
  );
}
